import { SplitpayAnalyticsEvents, SplitPayData } from "@swiggy-private/payment-ui";

export enum SplitPayMethodValues {
    DEFAULT = "default",
    NONE = "none",
}

export enum TURBO_VARIANT {
    DEFAULT = "turboV1",
    TURBO_V2 = "turboV2",
}

export interface SplitPayActions {
    onSplitPayToggle: (isSelected: boolean, methodData: SplitPayData, removeReward?: boolean) => void;
    isRewardsBottomSheetVisible: boolean;
    setIsRewardsBottomSheetVisible: (val: boolean) => void;
    analyticsEvents: SplitpayAnalyticsEvents;
}

export interface CroutonState {
    title: string;
    durationOfCrouton: number;
    icon: string;
}
